/** Filas extra por defecto a cada lado del viewport visible. */
export const DEFAULT_OVERSCAN_ROWS = 3

/** Ítems por fila por defecto (lista de una columna). */
export const DEFAULT_COLUMNS = 1
